export default {
    path: "email",
    name: "Email",
    meta: {
        title: "common.email",
    },
    component: () => import("../../views/Email.vue"),
    redirect: "/email/inbox",
    children: [
        {
            path: "systemPrompt",
            name: "SystemPrompt",
            meta: {
                title: "common.system.tip",
            },
            component: () => import("../../views/PositionStationDate.vue"),
        },
        {
            path: "folder/:folderId",
            name: "Folder",
            meta: {
                title: "common.folder",
            },
            component: () => import("../../views/Mail/Folder.vue"),
        },
        {
            path: "foldergroup",
            name: "FolderGroup",
            meta: {
                title: "system.group.folder",
            },
            component: () => import("../../views/Mail/FolderGroup.vue"),
        },
        {
            path: "group_setting",
            name: "GroupSetting",
            meta: {
                title: "common.team.management",
            },
            component: () => import("../../views/Group/index.vue"),
        },
        {
            path: "account_setting",
            name: "AccountSetting",
            meta: {
                title: "common.setting.email",
            },
            component: () => import("../../views/AccountSetting.vue"),
        },
        {
            path: "write_mail",
            name: "WriteMail1_Mail",
            meta: {
                title: "common.email.sending",
            },
            component: () => import("../../views/Mail/WriteMail.vue"),
        },
        {
            path: "inbox",
            name: "Inbox",
            meta: {
                title: "common.emailbox.receive",
            },
            component: () => import("../../views/Inbox.vue"),
        },
        {
            path: "has_send",
            name: "HasSend",
            meta: {
                title: "common.has.sent",
            },
            component: () => import("../../views/HasSend.vue"),
        },
        {
            path: "draft",
            name: "Draft",
            meta: {
                title: "common.draftsbox",
            },
            component: () => import("../../views/Draft.vue"),
        },
        {
            path: "waste",
            name: "Waste",
            meta: {
                title: "common.dustbin",
            },
            component: () => import("../../views/Waste.vue"),
        },
        {
            path: "examine",
            name: "Examine",
            meta: {
                title: "common.email.examine",
            },
            component: () => import("../../views/Mail/Examine.vue"),
        },
        {
            path: "follow_up",
            name: "FollowUp",
            meta: {
                title: "common.email.follow",
            },
            component: () => import("../../views/Mail/FollowUp.vue"),
        },
        {
            path: "customer",
            name: "Customer",
            meta: {
                title: "common.customer",
            },
            children: [
                {
                    path: "list",
                    name: "List",
                    meta: {
                        title: "common_customer_list",
                    },
                    component: () => import("../../views/Customer/List.vue"),
                },
                {
                    path: "public",
                    name: "Public",
                    meta: {
                        title: "common.customer.public",
                    },
                    component: () => import("../../views/Customer/Public.vue"),
                },
                {
                    path: "setting",
                    name: "Setting",
                    meta: {
                        title: "common.customer.management",
                    },
                    component: () => import("../../views/Customer/Setting.vue"),
                },
                {
                    path: "sending",
                    name: "Sending",
                    meta: {
                        title: "sending.customer.group.text",
                    },
                    component: () => import("../../views/SendGroup/Sending.vue"),
                },
                {
                    path: "senddetail/:massTaskId/:type/:taskId/:userId",
                    name: "SendDetail",
                    meta: {
                        title: "common.sys.task.detail",
                    },
                    component: () => import("../../views/SendGroup/SendingDetail.vue"),
                },
                {
                    path: "follow",
                    name: "Follow",
                    meta: {
                        title: "common.customer.followup.remind",
                    },
                    component: () => import("../../views/Customer/Follow.vue"),
                },
                {
                    path: "create",
                    name: "Create",
                    meta: {
                        title: "common.khjd",
                    },
                    component: () => import("../../views/Customer/Create.vue"),
                },
                {
                    path: "detail/:userId",
                    name: "Detail",
                    meta: {
                        title: "common.customer.details",
                    },
                    component: () => import("../../views/Customer/Detail.vue"),
                },
            ],
        },
        {
            path: "detail/:id/:flag/:type",
            name: "DetailEmail",
            meta: {
                title: "common.ph25",
            },
            component: () => import("../../views/Mail/Detail.vue"),
        },
    ],
};
